import { render, staticRenderFns } from "./embed-setup.vue?vue&type=template&id=3c8269a4&scoped=true&"
import script from "./embed-setup.vue?vue&type=script&lang=js&"
export * from "./embed-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8269a4",
  null
  
)

export default component.exports